var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('search'),_c('div',[_c('router-link',{class:[
        _vm.$style.button,
        ( _obj = {}, _obj[_vm.$style.active] = _vm.$route.query.view === 'table', _obj ) ],attrs:{"to":_vm.getRouterLink('table'),"replace":""}},[_vm._v(" Таблица ")]),_c('router-link',{class:[
        _vm.$style.button,
        ( _obj$1 = {}, _obj$1[_vm.$style.active] = _vm.$route.query.view === 'grid', _obj$1 ) ],attrs:{"to":_vm.getRouterLink('grid'),"replace":""}},[_vm._v(" Эскизы ")])],1),(_vm.visible)?_c('div',{ref:"printContainer",class:_vm.$style.hidden},[_c('screenshots-table')],1):_vm._e(),_c('export')],1)}
var staticRenderFns = []

export { render, staticRenderFns }